export function formatSichples(value) {
  if (!/^-?\d+(\.\d{1,2})?$/.test(String(value))) return '—';
  const [whole, fraction = ''] = String(value).split('.');
  const sign = String(value).startsWith('-') && BigInt(whole) === 0n ? '-' : '';
  return `${sign}${new Intl.NumberFormat('es-GT').format(BigInt(whole))}.${fraction.padEnd(2, '0')}`;
}
